import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import Navbar from "@xtribe/shared/components/lib/Navbar/Navbar";
const DatenschutzPage = () => {
  return (
    <div>
      <NextHead
        title={"Unsere Datenschutzerklärung — xTribe"}
        description={"Hier findest du unsere Datenschutzerklärung"}
      />
      <Navbar />
      <Layout>
        <main className="mt-12 text-gray-700 max-w-6xl mx-auto px-2 md:px-4">
          <article className="page">
            <div className="page_wrapper u-cw">
              <div className="text-center mb-16">
                <h2 className="h2">Datenschutzerklärung</h2>
                <p className="page_last-edit fs4">July 19, 2018</p>
              </div>
              <div className="page_content text">
                <p className="mb-4">Stand: 27.06.2018 </p>
                <p className="mb-4">
                  <b>
                    Information über die Erhebung personenbezogener Daten und
                    Anbieterkennzeichnung
                  </b>{" "}
                </p>
                <p className="mb-3">
                  Dieses Dokument informiert Sie darüber, welche
                  personenbezogenen Daten die von xTribe – Erik Wilhelm, Fürther
                  Str. 34, 90574 Roßtal, E-Mail:&nbsp;
                  <a href="mailto:privacy@xtribe.app">privacy@xtribe.app </a>
                  &nbsp;(nachfolgend "xTribe"), erhebt, verarbeitet und nutzt,
                  für welche Zwecke dies erfolgt und wie Sie bestimmten
                  Erhebungen, Verarbeitungen oder Nutzungen Ihrer
                  personenbezogenen Daten widersprechen können.{" "}
                </p>
                <p className="p6">
                  <b>Allgemein Hinweise und Pflichtinformationen</b>{" "}
                </p>
                <p className="mb-3">
                  xTribe nimmt den Schutz Ihrer persönlichen Daten sehr ernst.
                  Wir behandeln Ihre personenbezogenen Daten vertraulich und
                  entsprechend der gesetzlichen Datenschutzvorschriften sowie
                  dieser Datenschutzerklärung.{" "}
                </p>
                <p className="mb-3">
                  Wenn Sie diese Website benutzen, können verschiedene
                  personenbezogene Daten erhoben werden. Personenbezogene Daten
                  sind Daten, mit denen Sie persönlich identifiziert werden
                  können. Die vorliegende Datenschutzerklärung erläutert, welche
                  Daten wir erheben und wofür wir sie nutzen. Sie erläutert
                  auch, wie und zu welchem Zweck das geschieht.{" "}
                </p>
                <p className="mb-3">
                  Wir weisen darauf hin, dass die Datenübertragung im Internet
                  (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken
                  aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                  Zugriff durch Dritte ist nicht möglich.{" "}
                </p>
                <p className="mb-3">
                  Diese Datenschutz-Information gilt für die Datenverarbeitung
                  durch: <br />
                  Erik Wilhelm{" "}
                </p>
                <p className="mb-3">FÜrther Str. 34, 90574 Roßtal </p>
                <p className="mb-2">
                  Diese Datenschutzerklärung gilt für die nachfolgend genannte
                  Domain:{" "}
                </p>

                <a href="http://xtribe.app">xtribe.app </a>
                <p className="mb-4 mt-4">
                  <b>
                    Erhebung und Speicherung personenbezogener Daten sowie Art
                    und Zweck von deren Verwendung
                  </b>{" "}
                </p>
                <p className="mb-2">
                  <strong>Bei Besuch der Webseite </strong>
                </p>
                <p className="mb-3">
                  Beim Aufrufen unserer Website werden durch den auf Ihrem
                  Endgerät zum Einsatz kommenden Browser automatisch
                  Informationen an den Server unserer Website gesendet. Diese
                  Informationen werden temporär in einem sogenannten Logfile
                  gespeichert. Folgende Informationen werden dabei ohne Ihr
                  Zutun erfasst und bis zur automatisierten Löschung
                  gespeichert:{" "}
                </p>
                <ul className="ul1">
                  <li className="mb-2">
                    IP-Adresse des anfragenden Rechners,{" "}
                  </li>
                  <li className="mb-2">Datum und Uhrzeit des Zugriffs, </li>
                  <li className="mb-2">Name und URL der abgerufenen Datei, </li>
                  <li className="mb-2">
                    Website, von der aus der Zugriff erfolgt (Referrer-URL),{" "}
                  </li>
                  <li className="mb-2">
                    verwendeter Browser und ggf. das Betriebssystem Ihres
                    Rechners sowie der Name Ihres Access-Providers.{" "}
                  </li>
                </ul>
                <p className="mb-3">
                  Die genannten Daten werden durch uns zu folgenden Zwecken
                  verarbeitet:{" "}
                </p>
                <ul className="ul1">
                  <li className="mb-2">
                    Gewährleistung eines reibungslosen Verbindungsaufbaus der
                    Website,{" "}
                  </li>
                  <li className="mb-2">
                    Gewährleistung einer komfortablen Nutzung unserer Website,{" "}
                  </li>
                  <li className="mb-2">
                    Auswertung der Systemsicherheit und -stabilität sowie{" "}
                  </li>
                  <li className="mb-2">
                    zu weiteren administrativen Zwecken.{" "}
                  </li>
                </ul>
                <p className="mb-3">
                  Die Rechtsgrundlage für die Datenverarbeitung ist Art.&nbsp;6
                  Abs.&nbsp;1 S.&nbsp;1 lit.&nbsp;f DSGVO. Unser berechtigtes
                  Interesse folgt aus oben aufgelisteten Zwecken zur
                  Datenerhebung. In keinem Fall verwenden wir die erhobenen
                  Daten zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen.{" "}
                </p>
                <p className="mb-3">
                  Darüber hinaus setzen wir beim Besuch unserer Website Cookies
                  ein. Nähere Erläuterungen dazu erhalten Sie im Abschnitt
                  „Cookies“ dieser Datenschutzerklärung.{" "}
                </p>
                <p className="mb-2">
                  <strong>Bei Anmeldung für unseren Newsletter </strong>
                </p>
                <p className="mb-3">
                  Sofern Sie nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrücklich
                  eingewilligt haben, verwenden wir Ihre E-Mail-Adresse dafür,
                  Ihnen regelmäßig unseren Newsletter zu übersenden.{" "}
                </p>
                <p className="mb-3">
                  Dafür benötigen wir von Ihnen eine E-Mail-Adresse sowie
                  Informationen, welche uns die Überprüfung gestatten, dass Sie
                  der Inhaber der angegebenen E-Mail-Adresse sind und mit dem
                  Empfang des Newsletters einverstanden sind. Weitere Daten
                  werden nicht erhoben. Diese Daten verwenden wir ausschließlich
                  für den Versand der angeforderten Informationen über
                  ActiveCampaign und geben sie nicht an Dritte weiter.{" "}
                </p>
                <p className="mb-3">
                  Mit der Anmeldung zum E-Mail-Newsletter werden Ihre IP-Adresse
                  und das Datum der Anmeldung gespeichert. Diese Speicherung
                  dient &nbsp;dem Nachweis im Fall, dass ein Dritter eine
                  E-Mailadresse missbraucht und sich ohne Wissen des
                  Berechtigten für den Newsletterempfang anmeldet.{" "}
                </p>
                <p className="mb-3">
                  Ihre Einwilligung zur Speicherung der Daten, der E-Mailadresse
                  sowie deren Nutzung zum Versand des E-Mail-Newsletters können
                  Sie jederzeit widerrufen. Der Widerruf kann über einen Link in
                  den E-Mail-Newslettern selbst oder per Mitteilung an die unten
                  stehende Kontaktmöglichkeit erfolgen.{" "}
                </p>
                <p className="mb-3">
                  Für den manuellen und automatisierten Versand von
                  Newsletter-Mails nutzen wir den
                  E-Mail-Marketing-Anbieter&nbsp;
                  <a href="http://www.activecampaign.com/">ActiveCampaign </a>,
                  Chicago, Illinois 60606, USA. Active Campaign hat sich zur
                  Einhaltung des&nbsp;&nbsp;
                  <a href="http://europa.eu/rapid/press-release_IP-16-433_de.htm">
                    EU-US Privacy Shield Abkommen{" "}
                  </a>
                  &nbsp;vom Februar 2016 verpflichtet.{" "}
                </p>
                <p className="mb-3">
                  Die Newsletter-Software erlaubt statistische Erhebungen über
                  Öffnung des Newsletters und Link-Klick-Verhalten.&nbsp;Diese
                  Informationen können aus&nbsp;technischen Gründen den
                  einzelnen Newsletter-Empfängern zugeordnet werden. Die
                  Auswertungen dienen zur Erkennung der Lesegewohnheiten der
                  Nutzer und der dementsprechenden Anpassung des Inhaltes an die
                  Interessen unserer Nutzer.&nbsp;{" "}
                </p>
                <p className="mb-3">
                  Falls Sie mit der Datenübermittlung an Active Campaign nicht
                  einverstanden sind, sehen Sie bitte von der Bestellung des
                  Newsletters ab. Um trotzdem auf dem Neuesten Stand zu bleiben,
                  folgen Sie uns gern bei Facebook und Instagram!{" "}
                </p>
                <p className="mb-2">
                  <strong>Bei Nutzung unseres Kontaktformulars </strong>
                </p>
                <p className="mb-3">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                  werden Ihre Angaben aus dem Anfrageformular inklusive der von
                  Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                  Anfrage und für den Fall von Anschlussfragen in&nbsp;Craft CMS
                  und ActiveCampaign&nbsp;gespeichert. Diese Daten geben wir
                  nicht ohne Ihre Einwilligung weiter.{" "}
                </p>
                <p className="mb-3">
                  Für die Speicherung und Verwaltung der Daten
                  (Customer-Relationship-Management) nutzen wir&nbsp;
                  <a href="http://www.activecampaign.com/">ActiveCampaign </a>,
                  Chicago, Illinois 60606, USA. Active Campaign hat sich zur
                  Einhaltung des&nbsp;&nbsp;
                  <a href="http://europa.eu/rapid/press-release_IP-16-433_de.htm">
                    EU-US Privacy Shield Abkommen{" "}
                  </a>
                  &nbsp;vom Februar 2016 verpflichtet.{" "}
                </p>
                {/* <p className="mb-3">
                  CraftCMS ist ein Content Management System der Pixel &amp;
                  Tonic, Inc.,&nbsp;1261 Lincoln Ave. Ste. 211. San Jose, CA
                  95125. United States. Wir nutzen dieses zur ersten
                  Verarbeitung der Daten, die in Kontaktformulare z.B. am Ende
                  von Quizzes eingegeben werden. Das Unternehmen bereitet
                  eigenen Aussagen zufolge gerade die DS-GVO-Konformität vor (
                  <a href="https://craftcms.com/privacy">
                    https://craftcms.com/privacy{" "}
                  </a>
                  ).{" "}
                </p> */}
                <p className="mb-3">
                  Die Verarbeitung der in das Kontaktformular eingegebenen Daten
                  erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art.
                  6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung
                  jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per
                  E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf
                  erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf
                  unberührt.{" "}
                </p>
                <p className="mb-3">
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben
                  in den von uns genutzten Systemen, bis Sie uns zur Löschung
                  auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
                  der Zweck für die Datenspeicherung entfällt (z.B. nach
                  abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende
                  gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen –
                  bleiben unberührt.{" "}
                </p>
                <p className="mb-2">
                  <strong>Registrierung/Kundenaccount </strong>
                </p>
                <p className="mb-3">
                  Wenn Sie einen Vertrag über die Nutzung von xTribe abschließen
                  möchten, werden Ihre Daten in einem Kundenkonto gespeichert.{" "}
                </p>
                <p className="mb-3">
                  Wir erheben personenbezogene Daten, wenn Sie uns diese im
                  Rahmen einer Vertragsanbahnung, bei einer Kontaktaufnahme oder
                  bei der Eröffnung eines Kundenkontos freiwillig mitteilen.
                  Felder mit Pflichtangaben sind als solche gekennzeichnet, da
                  wir in diesen Fällen die Daten zur Vertragsabwicklung, zur
                  Bearbeitung Ihrer Kontaktaufnahme oder Eröffnung des
                  Kundenkontos benötigen. Ohne diese Angabe kann die Bestellung
                  und/oder die Kontoeröffnung nicht abgeschlossen bzw. die
                  Kontaktaufnahme bearbeitet werden.{" "}
                </p>
                <p className="mb-3">
                  Welche Daten erhoben werden ist aus den Eingabeformularen
                  ersichtlich. Wir verwenden die von ihnen mitgeteilten Daten
                  gemäß Art. 6 Abs. 1 S. 1 lit. b DSGVO (notwendig zur
                  Vertragserfüllung) zur Vertragsabwicklung und Bearbeitung
                  Ihrer Anfragen. Nach vollständiger Abwicklung des Vertrages
                  oder Löschung Ihres Kundenkontos werden Ihre Daten für die
                  weitere Verarbeitung eingeschränkt und nach Ablauf der steuer-
                  und handelsrechtlichen Aufbewahrungsfristen gelöscht.{" "}
                </p>
                <p className="mb-3">
                  Eine weitere Nutzung der Daten erfolgt nur dann, wenn Sie
                  ausdrücklich in eine weitere Nutzung Ihrer Daten eingewilligt
                  haben oder wir uns eine darüber hinausgehende Datenverwendung
                  vorbehalten, die gesetzlich erlaubt ist und über die wir Sie
                  in dieser Erklärung informieren. Die Löschung Ihres
                  Kundenkontos ist jederzeit möglich und kann entweder durch
                  eine Nachricht an die genannte Kontaktmöglichkeit oder über
                  eine dafür vorgesehene Funktion im Kundenkonto erfolgen.{" "}
                </p>
                <p>
                  <strong>Chattool</strong>&nbsp;{" "}
                </p>
                <p>
                  Um Ihnen bei Fragen schnellstmöglich helfen zu können, nutzen
                  wir den Chatservice Intercom - London, Floor 2, 80 Great
                  Eastern St, London EC2A 3JL.&nbsp; Intercom hat sich zur
                  Einhaltung des&nbsp;&nbsp;
                  <a href="http://europa.eu/rapid/press-release_IP-16-433_de.htm">
                    EU-US Privacy Shield Abkommen
                  </a>
                  &nbsp;vom Februar 2016 verpflichtet. Mehr Informationen finden
                  Sie unter{" "}
                  <a href="https://www.intercom.com/de/terms-and-policies#eu-us">
                    EU-U.S. and Swiss-U.S. Privacy Shield Policy.
                  </a>
                </p>
                <p>
                  <strong>Webinar</strong>
                </p>
                <p>
                  Wenn Sie bei unseren kostenlosen Webinar teilnehmen, werden
                  Ihre Angaben aus dem Anmeldeformular inklusive der von Ihnen
                  dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
                  in EverWebinar gespeichert. Wenn Sie die Zusendung des damit
                  zusammenhängenden Newsletters wünschen, wird Ihre
                  E-Mail-Adresse in ActiveCampaign gespeichert. Diese Daten
                  geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p>
                  Für das Hosting und die Bereitstellung des Webinars nutzen wir
                  EverWebinar, Genesis Digital,&nbsp;LLC 7660 Fay Ave
                  #H184,&nbsp;La Jolla, CA 92037. EverWebinar ist Teil von
                  GenesisDigital, die sich als DS-GVO-konform ausweisen.
                </p>
                <p>
                  Für die Speicherung und Verwaltung der Daten
                  (Customer-Relationship-Management) und die Versendung des
                  Newsletters nutzen wir&nbsp;
                  <a href="http://www.activecampaign.com/">ActiveCampaign</a>,
                  Chicago, Illinois 60606, USA. Active Campaign hat sich zur
                  Einhaltung des&nbsp;&nbsp;
                  <a href="http://europa.eu/rapid/press-release_IP-16-433_de.htm">
                    EU-US Privacy Shield Abkommen
                  </a>
                  &nbsp;vom Februar 2016 verpflichtet.
                </p>
                <p>
                  Die Verarbeitung der in das Kontaktformular eingegebenen Daten
                  erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art.
                  6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung
                  jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per
                  E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf
                  erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf
                  unberührt.
                </p>
                <p>
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben
                  in den von uns genutzten Systemen, bis Sie uns zur Löschung
                  auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
                  der Zweck für die Datenspeicherung entfällt (z.B. nach
                  abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende
                  gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen –
                  bleiben unberührt.
                </p>
                <p className="mb-2">
                  <strong>Weitergabe von Daten </strong>
                </p>
                <p className="mb-3">
                  Eine Übermittlung Ihrer persönlichen Daten an Dritte zu
                  anderen als den in dieser Datenschutzerklärung aufgeführten
                  Zwecken findet nicht statt.{" "}
                </p>
                <p className="mb-3">
                  Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:{" "}
                </p>
                <ul className="ul1">
                  <li className="mb-2">
                    Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche
                    Einwilligung dazu erteilt haben,{" "}
                  </li>
                  <li className="mb-2">
                    die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur
                    Geltendmachung, Ausübung oder Verteidigung von
                    Rechtsansprüchen erforderlich ist und kein Grund zur Annahme
                    besteht, dass Sie ein überwiegendes schutzwürdiges Interesse
                    an der Nichtweitergabe Ihrer Daten haben,{" "}
                  </li>
                  <li className="mb-2">
                    für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S.
                    1 lit. c DSGVO eine gesetzliche Verpflichtung besteht, sowie{" "}
                  </li>
                  <li className="mb-2">
                    dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b
                    DSGVO für die Abwicklung von Vertragsverhältnissen mit Ihnen
                    erforderlich ist.{" "}
                  </li>
                </ul>
                <p className="mb-2">
                  <strong>Hosting </strong>
                </p>
                <p className="mb-3">
                  Zur Erbringung unserer Leistungen und dem Bereithalten des
                  Onlineangebots bedienen wir uns auch Dienstleistern, die die
                  technische Infrastruktur bereitstellen.{" "}
                </p>
                <p className="mb-3">
                  Mit unseren Dienstleistern haben wir eine
                  Auftragsverabeitungsvertrag geschlossen. Eine Liste der
                  Dienstleister finden Sie hier.{" "}
                </p>
                <p className="mb-2">
                  <strong>
                    Erhebung personenbezogener Daten bei informatorischer
                    Nutzung | Cookies{" "}
                  </strong>
                </p>
                <p className="mb-3">
                  Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es
                  sich um kleine Dateien, die Ihr Browser automatisch erstellt
                  und die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.)
                  gespeichert werden, wenn Sie unsere Seite besuchen. Cookies
                  richten auf Ihrem Endgerät keinen Schaden an, enthalten keine
                  Viren, Trojaner oder sonstige Schadsoftware.{" "}
                </p>
                <p className="mb-3">
                  In dem Cookie werden Informationen abgelegt, die sich jeweils
                  im Zusammenhang mit dem spezifisch eingesetzten Endgerät
                  ergeben. Dies bedeutet jedoch nicht, dass wir dadurch
                  unmittelbar Kenntnis von Ihrer Identität erhalten.{" "}
                </p>
                <p className="mb-3">
                  Der Einsatz von Cookies dient einerseits dazu, die Nutzung
                  unseres Angebots für Sie angenehmer zu gestalten. So setzen
                  wir sogenannte Session-Cookies ein, um zu erkennen, dass Sie
                  einzelne Seiten unserer Website bereits besucht haben. Diese
                  werden nach Verlassen unserer Seite automatisch gelöscht.{" "}
                </p>
                <p className="mb-3">
                  Darüber hinaus setzen wir ebenfalls zur Optimierung der
                  Benutzerfreundlichkeit temporäre Cookies ein, die für einen
                  bestimmten festgelegten Zeitraum auf Ihrem Endgerät
                  gespeichert werden. Besuchen Sie unsere Seite erneut, um
                  unsere Dienste in Anspruch zu nehmen, wird automatisch
                  erkannt, dass Sie bereits bei uns waren und welche Eingaben
                  und Einstellungen sie getätigt haben, um diese nicht noch
                  einmal eingeben zu müssen.{" "}
                </p>
                <p className="mb-3">
                  Zum anderen setzten wir Cookies ein, um die Nutzung unserer
                  Website statistisch zu erfassen und zum Zwecke der Optimierung
                  unseres Angebotes für Sie auszuwerten. Diese Cookies
                  ermöglichen es uns, bei einem erneuten Besuch unserer Seite
                  automatisch zu erkennen, dass Sie bereits bei uns waren. Diese
                  Cookies werden nach einer jeweils definierten Zeit automatisch
                  gelöscht.{" "}
                </p>
                <p className="mb-3">
                  Wir verwenden diese Daten nur für eigene Zwecke und zur
                  Ermittlung der Wirtschaftlichkeit der von uns veranlassten
                  Werbemaßnahmen. Ein weitergehendes Tracking erfolgt nicht. Die
                  von uns vorgenommene Auswertung erfolgt anonymisiert bezogen
                  auf unsere Werbekampagnen.{" "}
                </p>
                <p className="mb-3">
                  Die durch Cookies verarbeiteten Daten sind für die genannten
                  Zwecke zur Wahrung unserer berechtigten Interessen sowie der
                  Dritter nach Art.&nbsp;6 Abs.&nbsp;1 S.&nbsp;1 lit.&nbsp;f
                  DSGVO erforderlich.{" "}
                </p>
                <p className="mb-3">
                  Sie können Ihren Browser so einstellen, dass Sie über das
                  Setzen von Cookies informiert werden und Cookies nur im
                  Einzelfall erlauben, die Annahme von Cookies für bestimmte
                  Fälle oder generell ausschließen sowie das automatische
                  Löschen der Cookies beim Schließen des Browser
                  aktivieren.&nbsp;{" "}
                </p>
                <p className="mb-2">
                  <strong>Analyse/Tracking-Tools </strong>
                </p>
                <p className="mb-3">
                  Die im Folgenden aufgeführten und von uns eingesetzten
                  Tracking-Maßnahmen werden auf Grundlage des Art. 6 Abs. 1 S. 1
                  lit. f DSGVO durchgeführt. Mit den zum Einsatz kommenden
                  Tracking-Maßnahmen wollen wir eine bedarfsgerechte Gestaltung
                  und die fortlaufende Optimierung unserer Webseite
                  sicherstellen. Zum anderen setzen wir die Tracking-Maßnahmen
                  ein, um die Nutzung unserer Webseite statistisch zu erfassen
                  und zum Zwecke der Optimierung unseres Angebotes für Sie
                  auszuwerten. Diese Interessen sind als berechtigt im Sinne der
                  vorgenannten Vorschrift anzusehen.{" "}
                </p>
                <p className="mb-3">
                  Zugleich zeigen wir Ihnen beim Aufruf unserer Webseite einen
                  Hinweis an, dass wir ein Tracking durchführen. Wenn Sie mit
                  dem Tracking einverstanden sind, können Sie die nachfolgend
                  beschriebenen Opt-out-Funktionen dennoch anwenden.{" "}
                </p>
                <p className="mb-3">
                  Die jeweiligen Datenverarbeitungszwecke und Datenkategorien
                  sind aus den entsprechenden Tracking-Tools zu entnehmen.{" "}
                </p>
                <p className="p17">
                  <strong>Google Analytics </strong>
                </p>
                <p className="mb-3">
                  Soweit Sie Ihre Einwilligung erklärt haben, wird auf dieser
                  Website Google Analytics eingesetzt, ein Webanalysedienst der
                  Google Inc. 1600 Amphitheatre Parkway Mountain View, CA 94043,
                  USA.{" "}
                </p>
                <p className="mb-3">
                  Die Nutzung umfasst die Betriebsart Universal Analytics.
                  Hierdurch ist es möglich, Daten, Sitzungen und Interaktionen
                  über mehrere Geräte hinweg einer pseudonymen User-ID
                  zuzuordnen und so die Aktivitäten eines Nutzers
                  geräteübergreifend zu analysieren. Dieser Datenschutzhinweis
                  wird zur Verfügung gestellt von&nbsp;
                  <a href="https://www.intersoft-consulting.de/">
                    https://www.intersoft-consulting.de{" "}
                  </a>
                  .{" "}
                </p>
                <p className="mb-3">
                  Google Analytics verwendet sog. „Cookies“. Das sind
                  Textdateien, die auf Ihrem Computer gespeichert werden und die
                  eine Analyse der Benutzung der Website durch Sie ermöglichen.
                  Die durch den Cookie erzeugten Informationen über Ihre
                  Benutzung dieser Website werden in der Regel an einen Server
                  von Google in den USA übertragen und dort gespeichert. <br />
                  Im Falle der Aktivierung der IP-Anonymisierung auf dieser
                  Webseite wird Ihre IP-Adresse von Google jedoch innerhalb von
                  Mitgliedstaaten der Europäischen Union oder in anderen
                  Vertragsstaaten des Abkommens über den Europäischen
                  Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die
                  volle IP-Adresse an einen Server von Google in den USA
                  übertragen und dort gekürzt.{" "}
                </p>
                <p className="mb-3">
                  Wir weisen Sie darauf hin, dass auf dieser Webseite Google
                  Analytics um eine IP-Anonymisierung erweitert wurde, um eine
                  anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu
                  gewährleisten. Die im Rahmen von Google Analytics von Ihrem
                  Browser übermittelte IP-Adresse wird nicht mit anderen Daten
                  von Google zusammengeführt. Nähere Informationen zu
                  Nutzungsbedingungen und Datenschutz finden Sie unter{" "}
                  <a href="http://www.google.com/analytics/terms/de">
                    Google Terms &amp; Conditions{" "}
                  </a>
                  &nbsp;und in den&nbsp;
                  <a href="https://policies.google.com/?hl=de">
                    Datenschutz &amp; Nutzungsbedingungen{" "}
                  </a>
                  .{" "}
                </p>
                <p className="p18">
                  <em>Zwecke der Verarbeitung </em>
                </p>
                <p className="mb-3">
                  Im Auftrag des Betreibers dieser Website wird Google diese
                  Informationen benutzen, um Ihre Nutzung der Website
                  auszuwerten, um Reports über die Websiteaktivitäten
                  zusammenzustellen und um weitere mit der Websitenutzung und
                  der Internetnutzung verbundene Dienstleistungen gegenüber dem
                  Websitebetreiber zu erbringen.&nbsp;{" "}
                </p>
                <p className="p18">
                  <em>Rechtsgrundlage </em>
                </p>
                <p className="mb-3">
                  Die Rechtsgrundlage für den Einsatz von Google Analytics ist
                  Ihre Einwilligung gemäß&nbsp;
                  <a href="https://dsgvo-gesetz.de/art-6-dsgvo/">
                    Art. 6 Abs. 1 S.1 lit. a DSGVO{" "}
                  </a>
                  .{" "}
                </p>
                <p className="p18">
                  <em>Empfänger / Kategorien von Empfängern </em>
                </p>
                <p className="p19">
                  Der Empfänger der erhobenen Daten ist Google.{" "}
                </p>
                <p className="p18">
                  <em>Übermittlung in Drittstaaten </em>
                </p>
                <p className="mb-3">
                  Die personenbezogenen Daten werden unter dem EU-US Privacy
                  Shield auf Grundlage des Angemessenheitsbeschlusses der
                  Europäischen Kommission in die USA übermittelt. Das Zertifikat
                  können Sie&nbsp;
                  <a href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI">
                    hier{" "}
                  </a>
                  &nbsp;abrufen.{" "}
                </p>
                <p className="p18">
                  <em>Dauer der Datenspeicherung </em>
                </p>
                <p className="mb-3">
                  Die von uns gesendeten und mit Cookies, Nutzerkennungen (z. B.
                  User-ID) oder Werbe-IDs verknüpften Daten werden nach 14
                  Monaten automatisch gelöscht. Die Löschung von Daten, deren
                  Aufbewahrungsdauer erreicht ist, erfolgt automatisch einmal im
                  Monat.{" "}
                </p>
                <p className="p18">
                  <em>Betroffenenrechte </em>
                </p>
                <p className="mb-3">
                  Sie können Ihre Einwilligung jederzeit mit Wirkung für die
                  Zukunft widerrufen, indem Sie die Speicherung der Cookies
                  durch eine entsprechende Einstellung Ihrer Browser-Software
                  verhindern; wir weisen Sie jedoch darauf hin, dass Sie in
                  diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
                  Website vollumfänglich werden nutzen können.{" "}
                </p>
                <p className="mb-3">
                  Sie können darüber hinaus die Erfassung der durch das Cookie
                  erzeugten und auf Ihre Nutzung der Website bezogenen Daten
                  (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung
                  dieser Daten durch Google verhindern, indem Sie das{" "}
                  <a href="https://tools.google.com/dlpage/gaoptout?hl=de">
                    Browser-Add-On{" "}
                  </a>
                  &nbsp;herunterladen und installieren. Opt-Out-Cookies
                  verhindern die zukünftige Erfassung Ihrer Daten beim Besuch
                  dieser Website. Um die Erfassung durch Universal Analytics
                  über verschiedene Geräte hinweg zu verhindern, müssen Sie das
                  Opt-Out auf allen genutzten Systemen durchführen.&nbsp;Sie
                  können Google Analytics für Display-Werbung deaktivieren und
                  die Anzeigen im Google Display-Netzwerk anpassen, indem Sie
                  die Anzeigeneinstellungen aufrufen:&nbsp;
                  <a href="http://www.google.de/settings/ads">
                    www.google.de/settings/ads{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>Google Tag Manager </strong>
                </p>
                <p className="mb-3">
                  Diese Webseite verwendet den Google Tag Manager. Durch diesen
                  Dienst können Website-Tags über eine Oberfläche verwaltet
                  werden. Der Google Tool Manager implementiert lediglich Tags.
                  Das bedeutet: Es werden keine Cookies eingesetzt und es werden
                  keine personenbezogenen Daten erfasst. Der Google Tool Manager
                  löst andere Tags aus, die wiederum ggf. Daten erfassen. Jedoch
                  greift der Google Tag Manager nicht auf diese Daten zu. Wurde
                  auf Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen,
                  so bleibt sie für alle Tracking-Tags bestehen, insofern diese
                  mit dem Google Tag Manager implementiert werden.{" "}
                </p>
                <p className="mb-2">
                  <strong>Google Re-Targeting </strong>
                </p>
                <p className="mb-3">
                  Diese Website verwendet Retargeting-Technologie der Google
                  Inc. („Google”). Diese ermöglicht es, Besucher unserer
                  Internetseiten gezielt mit personalisierter,
                  interessenbezogener Werbung anzusprechen, die sich bereits für
                  unsere Produkte interessiert haben. Die Einblendung der
                  Werbemittel erfolgt dabei auf Basis einer Cookie-basierten
                  Analyse des früheren Nutzungsverhaltens, wobei aber keine
                  personenbezogenen Daten gespeichert werden. In den Fällen der
                  Retargeting-Technologie wird ein Cookie auf Ihrem Computer
                  oder mobilen Endgerät gespeichert, um anonymisierte Daten über
                  Ihre Interessen zu erfassen und so die Werbung individuell auf
                  die gespeicherten Informationen anzupassen. Sie bekommen
                  dadurch Werbung angezeigt, die mit hoher Wahrscheinlichkeit
                  Ihren Produkt- und Informationsinteressen entspricht. Sie
                  können der Setzung von Cookies für Anzeigenvorgaben dauerhaft
                  widersprechen, indem Sie das unter folgendem Link verfügbare
                  Browser-Plug-in herunterladen und installieren:&nbsp;
                  <a href="http://www.google.com/ads/preferences/html/intl/de/plugin/">
                    http://www.google.com/ads/preferences/html/intl/de/plugin/{" "}
                  </a>{" "}
                </p>
                <p className="mb-3">
                  Weitergehende Informationen und die Datenschutzbestimmungen
                  bezüglich Werbung und Google können Sie hier einsehen:&nbsp;
                  <a href="http://www.google.com/privacy/ads/">
                    http://www.google.com/privacy/ads/{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>Einbindung der Dienste Dritter </strong>
                </p>
                <p className="mb-3">
                  Wir nutzen auf unseren Webseiten auf Grundlage unserer
                  berechtigten Interessen (Interesse an der Analyse, Optimierung
                  und Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1
                  lit. f. DSGVO) Inhalts- oder Serviceangebote von
                  Drittanbietern.{" "}
                </p>
                <p className="mb-3">
                  Für die Funktion dieser Inhalte ist Voraussetzung, dass die
                  Anbieter dieser Angebote die IP-Adresse der Nutzer wahrnehmen.
                  Die IP-Adresse ist für die Darstellung und Nutzung dieser
                  Inhalte erforderlich.{" "}
                </p>
                <p className="mb-3">
                  Die Drittanbieter können jedoch auch Pixel-Tags oder Cookies
                  für statistische Zwecke oder Marketingzwecke einsetzen.
                  Pixel-Tags sind unsichtbare Grafiken und werden auch als "Web
                  Beacons" bezeichnet. Den Anbietern ist damit möglich weitere
                  Informationen über die Nutzung von Webseiten zu ermitteln und
                  auszuwerten. Wir informieren Sie in dieser
                  Datenschutzerklärung wie Sie die Nutzung der im Regelfall
                  anonymen Daten unterbinden und einschränken können.{" "}
                </p>
                <p className="p6">
                  <strong>Social Media Plugins </strong>
                </p>
                <p className="mb-2">
                  <strong>Facebook </strong>
                </p>
                <p className="mb-3">
                  Auf unseren Seiten sind Plugins des sozialen Netzwerks
                  Facebook, Anbieter Facebook Inc., 1 Hacker Way, Menlo Park,
                  California 94025, USA, integriert. Die Facebook-Plugins
                  erkennen Sie an dem Facebook-Logo oder dem „Like-Button“
                  („Gefällt mir“) auf unserer Seite. Eine Übersicht über die
                  Facebook-Plugins finden Sie hier:&nbsp;
                  <a href="http://developers.facebook.com/docs/plugins/">
                    http://developers.facebook.com/docs/plugins/{" "}
                  </a>
                  . <br />
                  Wenn Sie unsere Seiten besuchen, wird über das Plugin eine
                  direkte Verbindung zwischen Ihrem Browser und dem
                  Facebook-Server hergestellt. Facebook erhält dadurch die
                  Information, dass Sie mit Ihrer IP-Adresse unsere Seite
                  besucht haben. Wenn Sie den Facebook „Like-Button“ anklicken
                  während Sie in Ihrem Facebook-Account eingeloggt sind, können
                  Sie die Inhalte unserer Seiten auf Ihrem Facebook-Profil
                  verlinken. Dadurch kann Facebook den Besuch unserer Seiten
                  Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir
                  als Anbieter der Seiten keine Kenntnis vom Inhalt der
                  übermittelten Daten sowie deren Nutzung durch Facebook
                  erhalten. Weitere Informationen hierzu finden Sie in der
                  Datenschutzerklärung von Facebook unter&nbsp;
                  <a href="http://de-de.facebook.com/policy.php">
                    http://de-de.facebook.com/policy.php{" "}
                  </a>
                  . <br />
                  Wenn Sie nicht wünschen, dass Facebook den Besuch unserer
                  Seiten Ihrem Facebook- Nutzerkonto zuordnen kann, loggen Sie
                  sich bitte aus Ihrem Facebook-Benutzerkonto aus.{" "}
                </p>
                <p className="mb-2">
                  <strong>Facebook Tracking Pixel </strong>
                </p>
                <p className="mb-3">
                  Innerhalb unseres Internetauftritts setzen wir mit Ihrer
                  Einwilligung das „Tracking-Pixel” der Facebook Inc., 1601 S.
                  California Ave, Palo Alto, CA 94304, USA (“Facebook”) ein. Mit
                  Hilfe dieses Pixels kann das Verhalten von Nutzern
                  nachverfolgt werden, nachdem diese durch Klick auf eine
                  Facebook-Werbeanzeige auf unsere Website weitergeleitet
                  wurden. So können wir die Wirksamkeit der
                  Facebook-Werbeanzeigen für statistische und
                  Marktforschungszwecke erfassen. Die so erfassten Daten sind
                  für uns anonym, das heißt wir sehen nicht die
                  personenbezogenen Daten einzelner Nutzer. Diese Daten werden
                  jedoch von Facebook gespeichert und verarbeitet, worüber wir
                  Sie entsprechend unserem Kenntnisstand unterrichten. Facebook
                  kann diese Daten mit ihrem Facebook-Konto verbinden und auch
                  für eigene Werbezwecke, entsprechend{" "}
                  <a href="https://www.facebook.com/about/privacy/">
                    Facebooks Datenverwendungsrichtlinie{" "}
                  </a>{" "}
                  verwenden. Sie haben die Möglichkeit, Facebook sowie dessen
                  Partnern das Schalten von Werbeanzeigen zu untersagen. Sie
                  können die Einstellungen für Facebooks Werbeanzeigen unter
                  folgendem Link bearbeiten:&nbsp;
                  <a href="https://www.facebook.com/ads/website_custom_audiences/">
                    https://www.facebook.com/ads/website_custom_audiences/{" "}
                  </a>
                  .{" "}
                </p>
                <p className="mb-2">
                  <strong>Facebook Custom Audiences </strong>
                </p>
                <p className="mb-3">
                  Wir setzen Kommunikationstools des sozialen Netzwerkes
                  Facebook ein, insbesondere das Produkt Custom Audiences und
                  Website Custom Audiences. Grundsätzlich wird dabei eine
                  nicht-reversible und nicht-personenbezogene Prüfsumme
                  (Hash-Wert) aus Ihren Nutzungsdaten generiert, die an Facebook
                  zu Analyse- und Marketingzwecken übermittelt werden kann. Für
                  das Produkt Website Custom Audiences wird der Facebook Cookie
                  angesprochen. <br />
                  Weitere Informationen über Zweck und Umfang der Datenerhebung
                  und die weitere Verarbeitung und Nutzung der Daten durch
                  Facebook sowie Ihre Einstellungsmöglichkeiten zum Schutz Ihrer
                  Privatsphäre entnehmen Sie bitte den Datenschutzrichtlinien
                  von Facebook, welche u.a. auf&nbsp;
                  <a href="https://www.facebook.com/ads/website_custom_audiences/">
                    https://www.facebook.com/ads/website_custom_audiences/&nbsp;{" "}
                  </a>
                  und&nbsp;
                  <a href="https://www.facebook.com/privacy/explanation">
                    https://www.facebook.com/privacy/explanation{" "}
                  </a>{" "}
                  zu finden sind. Wenn Sie der Nutzung von Facebook Website
                  Custom Audiences widersprechen möchten, können Sie dies
                  unter&nbsp;
                  <a href="https://www.facebook.com/ads/website_custom_audiences/">
                    https://www.facebook.com/ads/website_custom_audiences/{" "}
                  </a>
                  &nbsp;tun. Wenn Sie der Nutzung von Facebook Custom Audiences
                  widersprechen möchten, melden Sie sich bitte von unseren
                  Webservices ab.{" "}
                </p>
                <p className="mb-2">
                  <strong>Instagram </strong>
                </p>
                <p className="mb-3">
                  Auf unseren Seiten sind Funktionen des Dienstes Instagram
                  eingebunden. Diese Funktionen werden angeboten durch die
                  Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA.
                  Wenn Sie in Ihrem Instagram – Account eingeloggt sind, können
                  Sie durch Anklicken des Instagram – Buttons die Inhalte
                  unserer Seiten mit Ihrem Instagram – Profil verlinken. Dadurch
                  kann Instagram den Besuch unserer Seiten Ihrem Benutzerkonto
                  zuordnen. Wir weisen darauf hin, dass wir als Anbieter der
                  Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie
                  deren Nutzung durch Instagram erhalten. <br />
                  Weitere Informationen hierzu finden Sie in der
                  Datenschutzerklärung von Instagram:&nbsp;
                  <a href="http://instagram.com/about/legal/privacy/">
                    http://instagram.com/about/legal/privacy/{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>Pinterest </strong>
                </p>
                <p className="mb-3">
                  Auf unserer Seite verwenden wir Social Plugins des sozialen
                  Netzwerkes Pinterest, das von der Pinterest Inc., 635 High
                  Street, Palo Alto, CA, 94301, USA („Pinterest“) betrieben
                  wird. Wenn Sie eine Seite aufrufen die ein solches Plugin
                  enthält, stellt Ihr Browser eine direkte Verbindung zu den
                  Servern von Pinterest her. Das Plugin übermittelt dabei
                  Protokolldaten an den Server von Pinterest in die USA. Diese
                  Protokolldaten enthalten möglicherweise Ihre IP-Adresse, die
                  Adresse der besuchten Websites, die ebenfalls
                  Pinterest-Funktionen enthalten, Art und Einstellungen des
                  Browsers, Datum und Zeitpunkt der Anfrage, Ihre
                  Verwendungsweise von Pinterest sowie Cookies. <br />
                  Weitere Informationen zu Zweck, Umfang und weiterer
                  Verarbeitung und Nutzung der Daten durch Pinterest sowie Ihre
                  diesbezüglichen Rechte und Möglichkeiten zum Schutz Ihrer
                  Privatsphäre finden Sie in den den Datenschutzhinweisen von
                  Pinterest:&nbsp;
                  <a href="https://about.pinterest.com/de/privacy-policy">
                    https://about.pinterest.com/de/privacy-policy{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>Twitter </strong>
                </p>
                <p className="mb-3">
                  Auf unseren Seiten sind Funktionen des Dienstes Twitter
                  eingebunden. Diese Funktionen werden angeboten durch die
                  Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA
                  94103, USA. Durch das Benutzen von Twitter und der Funktion
                  „Re-Tweet“ werden die von Ihnen besuchten Webseiten mit Ihrem
                  Twitter-Account verknüpft und anderen Nutzern bekannt gegeben.
                  Dabei werden auch Daten an Twitter übertragen. Wir weisen
                  darauf hin, dass wir als Anbieter der Seiten keine Kenntnis
                  vom Inhalt der übermittelten Daten sowie deren Nutzung durch
                  Twitter erhalten. Weitere Informationen hierzu finden Sie in
                  der Datenschutzerklärung von Twitter unter&nbsp;
                  <a href="http://twitter.com/privacy">
                    http://twitter.com/privacy{" "}
                  </a>
                  . <br />
                  Ihre Datenschutzeinstellungen bei Twitter können Sie in den
                  Konto-Einstellungen unter&nbsp;
                  <a href="http://twitter.com/account/settings">
                    http://twitter.com/account/settings{" "}
                  </a>
                  &nbsp;ändern. <br />
                </p>
                <p className="mb-2">
                  <strong>LinkedIn </strong>
                </p>
                <p className="mb-3">
                  Unsere Website nutzt Funktionen des Netzwerks LinkedIn.
                  Anbieter ist die LinkedIn Corporation, 2029 Stierlin Court,
                  Mountain View, CA 94043, USA. Bei jedem Abruf einer unserer
                  Seiten, die Funktionen von LinkedIn enthält, wird eine
                  Verbindung zu Servern von LinkedIn aufbaut. LinkedIn wird
                  darüber informiert, dass Sie unsere Internetseiten mit Ihrer
                  IP-Adresse besucht haben. Wenn Sie den „Recommend-Button“ von
                  LinkedIn anklicken und in Ihrem Account bei LinkedIn
                  eingeloggt sind, ist es LinkedIn möglich, Ihren Besuch auf
                  unserer Internetseite Ihnen und Ihrem Benutzerkonto
                  zuzuordnen. Wir weisen darauf hin, dass wir als Anbieter der
                  Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie
                  deren Nutzung durch LinkedIn haben. <br />
                  Weitere Informationen hierzu finden Sie in der
                  Datenschutzerklärung von LinkedIn unter:&nbsp;
                  <a href="https://www.linkedin.com/legal/privacy-policy">
                    https://www.linkedin.com/legal/privacy-policy{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>Xing </strong>
                </p>
                <p className="mb-3">
                  Unsere Webseite nutzt Funktionen des Netzwerks XING. Anbieter
                  ist die XING AG, Dammtorstraße 29-32, 20354 Hamburg,
                  Deutschland. Bei jedem Abruf einer unserer Seiten, die
                  Funktionen von Xing enthält, wird eine Verbindung zu Servern
                  von Xing hergestellt. Eine Speicherung von personenbezogenen
                  Daten erfolgt dabei nach unserer Kenntnis nicht. Insbesondere
                  werden keine IP-Adressen gespeichert oder das
                  Nutzungsverhalten ausgewertet. <br />
                  Weitere Information zum Datenschutz und dem Xing Share-Button
                  finden Sie in der Datenschutzerklärung von Xing unter&nbsp;
                  <a href="https://www.xing.com/app/share?op=data_protection">
                    https://www.xing.com/app/share?op=data_protection{" "}
                  </a>{" "}
                  <br />
                </p>
                <p className="mb-2">
                  <strong>YouTube </strong>
                </p>
                <p className="mb-3">
                  Unsere Webseite nutzt Plugins der von Google betriebenen Seite
                  YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry
                  Ave., San Bruno, CA 94066, USA. Wenn Sie eine unserer mit
                  einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine
                  Verbindung zu den Servern von YouTube hergestellt. Dabei wird
                  dem Youtube-Server mitgeteilt, welche unserer Seiten Sie
                  besucht haben. <br />
                  Wenn Sie in Ihrem YouTube-Account eingeloggt sind ermöglichen
                  Sie YouTube, Ihr Surfverhalten direkt Ihrem persönlichen
                  Profil zuzuordnen. Dies können Sie verhindern, indem Sie sich
                  aus Ihrem YouTube-Account ausloggen. <br />
                  Weitere Informationen zum Umgang von Nutzerdaten finden Sie in
                  der Datenschutzerklärung von YouTube unter&nbsp;
                  <a href="https://www.google.de/intl/de/policies/privacy">
                    https://www.google.de/intl/de/policies/privacy{" "}
                  </a>{" "}
                </p>
                <p className="mb-2">
                  <strong>
                    Datenschutz bei Bewerbungen und im Bewerbungsverfahren{" "}
                  </strong>
                </p>
                <p className="mb-3">
                  Wir erheben und verarbeiten personenbezogenen Daten von
                  Bewerbern zum Zwecke der Abwicklung des Bewerbungsverfahrens.
                  Die Verarbeitung kann auch auf elektronischem Wege erfolgen.
                  Dies ist insbesondere dann der Fall, wenn ein Bewerber
                  entsprechende Bewerbungsunterlagen auf dem elektronischen
                  Wege, beispielsweise per E-Mail an uns übermittelt. Schließen
                  wir einen Anstellungsvertrag mit einem Bewerber, werden die
                  übermittelten Daten zum Zwecke der Abwicklung des
                  Beschäftigungsverhältnisses unter Beachtung der gesetzlichen
                  Vorschriften gespeichert. Wird kein Anstellungsvertrag mit dem
                  Bewerber geschlossen, so werden die Bewerbungsunterlagen drei
                  Monate nach Bekanntgabe der Absageentscheidung von uns
                  gelöscht, sofern einer Löschung keine sonstigen berechtigten
                  Interessen entgegenstehen oder der/die Betroffene sich damit
                  einverstanden erklärt hat, die Daten für eine später in Frage
                  kommende Anstellung speichern zu lassen. Sonstiges
                  berechtigtes Interesse in diesem Sinne ist beispielsweise eine
                  Beweispflicht in einem Verfahren nach dem Allgemeinen
                  Gleichbehandlungsgesetz (AGG).{" "}
                </p>
                <p className="mb-3">
                  Die Verarbeitung der Daten erfolgt, weil Sie durch die
                  Übersendung einwilligen (Art. 6 Abs. 1 S. 1 lit. a DSGVO) und
                  wir diese dann im berechtigten Interesse verarbeiten (Art. 6
                  Abs. 1 S. lit. f DSGVO).{" "}
                </p>
                <p className="p24">
                  <strong>Widerspruchs- und Auskunftsrecht </strong>
                </p>
                <p className="mb-3">
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer
                  ausdrücklichen Einwilligung möglich. Sie können eine bereits
                  erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine
                  formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der
                  bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
                  Widerruf unberührt.{" "}
                </p>
                <p className="mb-3">
                  Besucher der Webseite{" "}
                  <a href="http://www.xtribe.app/">www.xtribe.app </a> und
                  Nutzer der Perspective-Software können eine erklärte
                  Einwilligung in die Verarbeitung ihrer personenbezogenen Daten
                  jederzeit mit Wirkung für die Zukunft widerrufen (Art.21
                  DS-GVO). Sie haben außerdem das Recht, Auskunft über die von
                  Perspective gespeicherten personenbezogenen Daten zu verlangen
                  (Art.15 DS-GVO).{" "}
                </p>
                <p className="mb-3">
                  Schicken Sie uns dafür bitte eine E-Mail mit entsprechendem
                  Betreff an&nbsp;
                  <a href="mailto:privacy@xtribe.app">privacy@xtribe.app </a>
                  .&nbsp;{" "}
                </p>
                <p className="mb-3">
                  Sind die Daten zur Erfüllung eines Vertrages oder zur
                  Durchführung vorvertraglicher Maßnahmen erforderlich, ist eine
                  vorzeitige Löschung der Daten nur möglich, soweit nicht
                  vertragliche oder gesetzliche Verpflichtungen einer Löschung
                  entgegenstehen.{" "}
                </p>
                <p className="mb-2">
                  <strong>Betroffenenrechte </strong>
                </p>
                <p className="mb-3">Sie haben das Recht: </p>
                <ul className="ul1">
                  <li className="mb-2">
                    gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten
                    personenbezogenen Daten zu verlangen. Insbesondere können
                    Sie Auskunft über die Verarbeitungszwecke, die Kategorie der
                    personenbezogenen Daten, die Kategorien von Empfängern,
                    gegenüber denen Ihre Daten offengelegt wurden oder werden,
                    die geplante Speicherdauer, das Bestehen eines Rechts auf
                    Berichtigung, Löschung, Einschränkung der Verarbeitung oder
                    Widerspruch, das Bestehen eines Beschwerderechts, die
                    Herkunft ihrer Daten, sofern diese nicht bei uns erhoben
                    wurden, sowie über das Bestehen einer automatisierten
                    Entscheidungsfindung einschließlich Profiling und ggf.
                    aussagekräftigen Informationen zu deren Einzelheiten
                    verlangen;{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 16 DSGVO unverzüglich die Berichtigung
                    unrichtiger oder Vervollständigung Ihrer bei uns
                    gespeicherten personenbezogenen Daten zu verlangen;{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten
                    personenbezogenen Daten zu verlangen, soweit nicht die
                    Verarbeitung zur Ausübung des Rechts auf freie
                    Meinungsäußerung und Information, zur Erfüllung einer
                    rechtlichen Verpflichtung, aus Gründen des öffentlichen
                    Interesses oder zur Geltendmachung, Ausübung oder
                    Verteidigung von Rechtsansprüchen erforderlich ist;{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer
                    personenbezogenen Daten zu verlangen, soweit die Richtigkeit
                    der Daten von Ihnen bestritten wird, die Verarbeitung
                    unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir
                    die Daten nicht mehr benötigen, Sie jedoch diese zur
                    Geltendmachung, Ausübung oder Verteidigung von
                    Rechtsansprüchen benötigen oder Sie gemäß Art.&nbsp;21 DSGVO
                    Widerspruch gegen die Verarbeitung eingelegt haben;{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie
                    uns bereitgestellt haben, in einem strukturierten, gängigen
                    und maschinenlesebaren Format zu erhalten oder die
                    Übermittlung an einen anderen Verantwortlichen zu verlangen;{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung
                    jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge,
                    dass wir die Datenverarbeitung, die auf dieser Einwilligung
                    beruhte, für die Zukunft nicht mehr fortführen dürfen und{" "}
                  </li>
                  <li className="mb-2">
                    gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu
                    beschweren. In der Regel können Sie sich hierfür an die
                    Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder
                    Arbeitsplatzes oder unseres Unternehmenssitzes wenden.{" "}
                  </li>
                </ul>
                <p className="mb-2">
                  <strong>Widerspruchsrecht </strong>
                </p>
                <p className="mb-3">
                  Sofern Ihre personenbezogenen Daten auf Grundlage von
                  berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO
                  verarbeitet werden, haben Sie das Recht, gemäß Art.&nbsp;21
                  DSGVO Widerspruch gegen die Verarbeitung Ihrer
                  personenbezogenen Daten einzulegen, soweit dafür Gründe
                  vorliegen, die sich aus Ihrer besonderen Situation ergeben
                  oder sich der Widerspruch gegen Direktwerbung richtet. Im
                  letzteren Fall haben Sie ein generelles Widerspruchsrecht, das
                  ohne Angabe einer besonderen Situation von uns umgesetzt wird.{" "}
                </p>
                <p className="mb-3">
                  Möchten Sie von Ihrem Widerrufs- oder Widerspruchsrecht
                  Gebrauch machen, genügt eine E-Mail an{" "}
                  <a href="mailto:privacy@xtribe.app">privacy@xtribe.app </a>.{" "}
                </p>
                <p className="mb-2">
                  <strong>SSL- bzw. TLS-Verschlüsselung </strong>
                </p>
                <p className="mb-3">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                  Übertragung vertraulicher Inhalte, wie zum Beispiel
                  Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber
                  senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte
                  Verbindung erkennen Sie daran, dass die Adresszeile des
                  Browsers von “http://” auf “https://” wechselt, sowie an dem
                  Schloss-Symbol in Ihrer Browserzeile.{" "}
                </p>
                <p className="mb-3">
                  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                  die Daten, die Sie an uns übermitteln, nicht von Dritten
                  mitgelesen werden.{" "}
                </p>
                <p className="mb-3">
                  Wir bedienen uns im Übrigen geeigneter technischer und
                  organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen
                  zufällige oder vorsätzliche Manipulationen, teilweisen oder
                  vollständigen Verlust, Zerstörung oder gegen den unbefugten
                  Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen
                  werden entsprechend der technologischen Entwicklung
                  fortlaufend verbessert.{" "}
                </p>
                <p className="p26">
                  <strong>
                    Umfang und Änderungen dieser Datenschutzerklärung{" "}
                  </strong>
                </p>
                <p className="mb-3">
                  Diese Datenschutzerklärung gilt ausschließlich für die Nutzung
                  der von uns angebotenen Internetseiten. Sie gilt nicht für die
                  Internetseiten anderer Dienste-Anbieter, auf die wir lediglich
                  durch einen Link verweisen. Für fremde mit unserem
                  Internetauftritt nicht im Zusammenhang stehenden Erklärungen
                  und Richtlinien übernehmen wir keine Verantwortung und
                  Haftung. <br />
                  Wir behalten uns das Recht vor, die vorstehenden
                  Datenschutzbestimmungen von Zeit zu Zeit entsprechend
                  künftiger Änderungen hinsichtlich der Erhebung und
                  Verarbeitung von personenbezogenen Daten anzupassen.{" "}
                </p>
                <p className="p28">
                  <strong>Datenschutzbeauftragter </strong>
                </p>
                <p className="mb-2">
                  <a href="mailto:datenschutzbeauftragter@datenschutzexperte.de">
                    datenschutzbeauftragter@datenschutzexperte.de
                  </a>{" "}
                  <br />
                  <a href="http://www.datenschutzexperte.de/">
                    www.datenschutzexperte.de
                  </a>
                </p>
                <p className="p29"></p>
              </div>
            </div>
          </article>
        </main>
      </Layout>
    </div>
  );
};

export default DatenschutzPage;
